var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_20759",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_20759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6925 33.3329C11.9467 33.3329 11.3116 33.0706 10.787 32.546C10.2624 32.0214 10.0002 31.3863 10.0002 30.6406V9.99953H8.3335V8.33287H15.0002V7.05078H25.0002V8.33287H31.6668V9.99953H30.0002V30.6406C30.0002 31.4077 29.7432 32.0481 29.2293 32.562C28.7154 33.0759 28.075 33.3329 27.3079 33.3329H12.6925ZM28.3335 9.99953H11.6668V30.6406C11.6668 30.9397 11.763 31.1854 11.9553 31.3777C12.1476 31.57 12.3933 31.6662 12.6925 31.6662H27.3079C27.5643 31.6662 27.7993 31.5594 28.013 31.3457C28.2267 31.132 28.3335 30.897 28.3335 30.6406V9.99953ZM16.3463 28.3329H18.013V13.3329H16.3463V28.3329ZM21.9873 28.3329H23.654V13.3329H21.9873V28.3329Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIc);
export default __webpack_public_path__ + "static/media/delete_ic.6d8de7ee16122bc3c4662145544edb6e.svg";
export { ForwardRef as ReactComponent };